module.exports = __webpack_public_path__ + "img/home1.668a16ea.jpg";